module.exports = __webpack_public_path__ + "images/psp/College/shutterstock.jpg";